import { useAuthFetchWithResponse } from '@e3dc-react/shell/Hooks/AuthFetch'
import { useQueryClient } from '@tanstack/react-query'
import { useCallback } from 'react'
import { WallboxConfigurationModel } from '..'
import { updateWallboxConfiguration } from '../api'
import { getWallboxConfigurationQueryKey } from './use-wallbox-configuration'
import { ApiResult, usePortalMutation } from 'src/Libs/api'

type UseWallboxConfigurationMutation = {
  mutateWallboxConfiguration: (
    wallboxStorageId: number | string,
    wallboxIndex: number | string,
    payload: Partial<WallboxConfigurationModel>
  ) => Promise<null>
  isLoading?: boolean
  isError?: boolean
}

const useWallboxConfigurationMutation = (): UseWallboxConfigurationMutation => {
  const authFetch = useAuthFetchWithResponse()
  const queryClient = useQueryClient()

  const { mutateAsync, isPending, isError } = usePortalMutation({
    mutationFn: async ({
      wallboxStorageId,
      wallboxIndex,
      payload,
    }: {
      wallboxStorageId: number | string
      wallboxIndex: number | string
      payload: Partial<WallboxConfigurationModel>
    }) => new ApiResult(await updateWallboxConfiguration(wallboxStorageId, wallboxIndex, payload, authFetch)),
    onSuccess: (_, { wallboxStorageId, wallboxIndex }) => {
      queryClient.invalidateQueries({ queryKey: getWallboxConfigurationQueryKey(wallboxStorageId.toString(), wallboxIndex.toString()) })
    },
  })

  const mutateWallboxConfiguration = useCallback(
    (wallboxStorageId: number | string, wallboxIndex: number | string, payload: Partial<WallboxConfigurationModel>) => {
      return mutateAsync({ wallboxStorageId, wallboxIndex, payload })
    },
    [mutateAsync]
  )

  return { mutateWallboxConfiguration, isLoading: isPending, isError }
}

export default useWallboxConfigurationMutation
